<template>
  <shop-audit-list title="实体店审核" :type="1"></shop-audit-list>
</template>

<script>
import ShopAuditList from "@view/components/shop/audit-list.vue";

export default {
  name: "",
  components: {ShopAuditList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
